<template>
  <modal 
    name="tender-announcements-modal"
    @before-open="handleBeforeOpen"
    @before-close="handleBeforeClose"
    style="z-index: 1001;"
  >
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">«{{password}}» մրցույթին առնչվող հայտարարություններ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('tender-announcements-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="pt-2 px-4 pb-4 position-relative" style="overflow-x: auto; height: 85%">
        <template v-if="loading">
          <span
            class="text-primary m-auto spinner-border spinner-border-lg position-absolute" 
            style="right: 0; top: 0; bottom: 0; left: 0;"
            role="status"
            aria-hidden="true"
          />
        </template>
        <template v-else>
          <div class="row">
            <div class="col-md-12">
                <template v-if="announcements.length">
                  <div class="list-group mb-3">
                    <h6>Մրցույթ՝</h6>
                    <a href="#" @click="() => handleGoToAnnouncement(tender.id)" class="list-group-item list-group-item-action">{{tender.title.hy}}</a>
                  </div>
                  <div class="list-group">
                    <h6>Հայտարարություններ՝</h6>
                    <a href="#" :key="announcement.id" v-for="announcement in announcements" @click="() => handleGoToAnnouncement(announcement.id)" class="list-group-item list-group-item-action">{{announcement.title.hy}}</a>
                  </div>
                </template>
                <div v-else>
                  <h5 class="text-center">Առնչվող հայտարարություններ չկան</h5>
                </div>
            </div>
          </div>
        </template>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'TenderAnnouncementsModal',
    components: {  },
    data() {
      return {
        id: '',
        password: '',
        announcements: [],
        tender: {},
        loading: false,
        handleGoToAnnouncement: () => {}
      }
    },
    methods: {
      handleBeforeOpen({params}) {
        this.loading = true;
        this.password = params.password
        this.id = params.id
        this.handleGoToAnnouncement = params.handleGoToAnnouncement
        this.$client.get(`tender/getByTenderId/${this.id}`).then(({data}) => {
          this.announcements = data.announcements
          this.tender = data.tender
          this.loading = false;
        })
      },
      handleBeforeClose(){
        this.announcements = [];
      },
    }
  }
</script>

<style scoped>
 .date-picker {
    display: block;
    width: 100%;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  /deep/ .vdpWithInput > input {
    width: 100%;
    height: calc(1.8em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.8;
    color: #303e67;
    border: none;
  }
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    position: absolute;
    width: 500px !important;
    height: 80% !important;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>